module.exports = __webpack_public_path__ + "img/shopware_logo_blue-RGB_VER.8b5fac9a.svg";